import { render, staticRenderFns } from "./PopupClinicList.vue?vue&type=template&id=389e9ecb&scoped=true&"
import script from "./PopupClinicList.vue?vue&type=script&lang=ts&"
export * from "./PopupClinicList.vue?vue&type=script&lang=ts&"
import style0 from "./PopupClinicList.vue?vue&type=style&index=0&id=389e9ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e9ecb",
  null
  
)

export default component.exports